import { useEffect } from 'react';

interface PageMeta {
  title: string;
  description: string;
  path?: string;
  jsonLd?: object[];
}

function setMeta(selector: string, attr: string, value: string, createTag: string, createAttr: string) {
  let el = document.head.querySelector<HTMLElement & { [key: string]: string }>(selector);
  if (!el) {
    el = document.createElement(createTag);
    el.setAttribute(createAttr, '');
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export default function usePageMeta({ title, description, path = '/', jsonLd }: PageMeta) {
  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', 'content', description, 'meta', 'name');
    setMeta('meta[property="og:title"]', 'content', title, 'meta', 'property');
    setMeta('meta[property="og:description"]', 'content', description, 'meta', 'property');
    const origin = window.location.origin;
    const fullUrl = `${origin}${path}`;
    const canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) canonical.href = fullUrl;

    document.querySelectorAll('script[data-page-jsonld]').forEach((n) => n.remove());
    if (jsonLd && jsonLd.length) {
      jsonLd.forEach((obj) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-page-jsonld', '');
        script.textContent = JSON.stringify(obj);
        document.head.appendChild(script);
      });
    }
  }, [title, description, path, jsonLd]);
}